import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import {
  Breakpoint,
  BreakpointState,
  MediaQueryService,
  ModalNotificationRegistryService,
  ModalNotificationLauncherService,
  ModalNotificationMultipleService,
  ModalTriggerConfiguration,
  ModalType
} from '@tdwb/core';

// eslint-disable-next-line td-wb-rules/change-detection-strategy-rule
@Component({
  selector: 'td-wb-modal-notification',
  templateUrl: 'modal-notification.component.html',
  styleUrls: ['modal-notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ModalNotificationComponent implements OnInit {

  @Input() triggerId: string;

  triggerContent: ModalTriggerConfiguration;
  currentPage: number = 0;
  isSmallMediumView: boolean;
  hasWhatsNewModalFeatureFlag: boolean = false;
  subModals: Array<ModalTriggerConfiguration> = [];
  readonly welcomeModals: Array<string> = ['welcome_modal_di', 'welcome_modal_fp_pia', 'welcome_modal_pic'];
  readonly modalType: ModalType = ModalType.WHATS_NEW;

  constructor(private modalNotificationLauncherService: ModalNotificationLauncherService,
              private modalNotificationMultipleService: ModalNotificationMultipleService,
              private modalNotificationInvocationRegistrationService: ModalNotificationRegistryService,
              private mediaQueryService: MediaQueryService) {
    this.mediaQueryService.observe(Breakpoint.SM, Breakpoint.MD)
      .pipe(takeUntilDestroyed())
      .subscribe((breakpointState: BreakpointState): void => {
        this.isSmallMediumView = breakpointState.matches;
      });
    this.hasWhatsNewModalFeatureFlag = this.modalNotificationMultipleService.hasMultipleWhatsNewModal();
  }

  ngOnInit(): void {
    if (this.hasWhatsNewModalFeatureFlag) {
      this.subModals = this.modalNotificationMultipleService.getMultipleWhatsNewModal();
      this.triggerId = this.subModals[this.currentPage]?.id;
    }
    this.fetchModalContent();
  }

  fetchModalContent(): void {
    if (this.triggerId) {
      this.triggerContent = this.modalNotificationLauncherService.getTrigger(this.triggerId);
    }
  }

  hasContent(): boolean {
    return this.triggerContent.contentURLs !== undefined && this.triggerContent.contentURLs.length > 0;
  }

  getCurrentPageLinkId(): string {
    return this.hasWhatsNewModalFeatureFlag ? this.triggerContent.contentURLs[0] : this.triggerContent.contentURLs[this.currentPage];
  }

  getModalNotificationTitle(): string {
    return this.welcomeModals.includes(this.triggerId) ?
      'tdWb.modalNotification.WELCOME_MODAL_TITLE' : 'tdWb.modalNotification.NOTIFICATION_MODAL_TITLE';
  }

  getIconId(): string {
    return 'modal--info';
  }

  isResponsiveView(): boolean {
    // eservices_blended_pic is the only non-responsive modal remaining
    // checking it this way allows responsive to be the new default, which is how it should be
    return this.triggerId !== 'eservices_blended_pic' && this.isSmallMediumView;
  }

  shouldShowPagination(): boolean {
    return this.triggerContent.contentURLs.length > 1 || this.subModals.length > 1;
  }

  shouldShowButtons(): boolean {
    return (this.triggerContent.buttons !== undefined &&
      Array.isArray(this.triggerContent.contentURLs) &&
      this.currentPage === this.triggerContent.contentURLs.length - 1)
      || (this.hasWhatsNewModalFeatureFlag && this.currentPage === this.subModals.length - 1);
  }

  pageChange(index: number): void {
    this.currentPage = index;
    if (this.hasWhatsNewModalFeatureFlag) {
      this.triggerId = this.subModals[this.currentPage]?.id;
      this.fetchModalContent();
      if (!this.modalNotificationInvocationRegistrationService.checkIfContentHasBeenLaunched(this.triggerContent)) {
        this.modalNotificationInvocationRegistrationService.registerLaunch(this.triggerContent);
      }
    }
  }
}
